<template>
    <div class="toolContainer">
        <div class="wrapCenter">
            <div class="tool_content">
                <p class="tool_title" :style="{color: color}">{{title}}</p>
                <ul class="tool_menus" :style="{color: color}">
                    <li>产品功能</li>
                    <li>产品参数</li>
                    <li><a href="https://tangmai.tmall.com" class="buy_bt">购买</a></li>
                </ul>
            </div>
        </div>
    </div>
    
</template>
<script>
export default {
    props:{
        title: String,
        color:{
            type: String,
            default: '#333'
        }
    }
}
</script>

<style scoped>
.toolContainer{
    top: 80px;
    width: 100%;
    position: absolute;
}

.wrapCenter{
    width: 1100px;
    padding: 32px 48px;
}

.toolContainer .tool_title{
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 2px;
}

.toolContainer .tool_menus{
    float: right;
}

.toolContainer .tool_menus li{
    float: left;
    margin: 0 14px;
    font-size: 12px;
}

.toolContainer .tool_menus li .buy_bt{
    background: #023eb9;
    color: #ffffff;
    width: 45px;
    height: 20px;
    line-height: 20px;
    border: none;
    display: block;
    text-align: center;
    border-radius: 10px;
    font-size: 12px;
}

@media (max-width: 768px) {
	.toolContainer{
        top: 2.56rem;
    }

    .wrapCenter{
        width: 100%;
        padding: 0.4267rem;
    }
    .toolContainer .tool_title{
        float: left;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/product_tool.vue